import React from 'react';
import PropTypes from 'prop-types';

import { LOCATION_LIST_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ScrollIntoView from 'bento-ordering/base/components/ScrollIntoView';

function LocationsList({
  beginOrder,
  locations,
  LocationsListItemComponent,
  selectedMapLocation
}) {
  return locations.map((location, index, arr) => {
    const isSelected = `${location.id}` === `${selectedMapLocation}`;
    const isLast = index === arr.length - 1;
    const cardWrapperMargin = isLast ? 1.25 : 1.75;

    return (
      <Box
        mb={cardWrapperMargin}
        component={ListItem}
        key={location.id}
        data-testid="location-list-item"
      >
        <ScrollIntoView shouldScrollIntoView={isSelected}>
          <LocationsListItemComponent
            locationObject={location}
            isSelected={isSelected}
            beginOrder={beginOrder}
          />
        </ScrollIntoView>
      </Box>
    );
  });
}

export default LocationsList;

LocationsList.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  locations: LOCATION_LIST_PROPTYPES,
  LocationsListItemComponent: PropTypes.elementType.isRequired,
  selectedMapLocation: PropTypes.number
};
